import React, { Component } from "react";
import s from "./styles.scss";
import { Button, FormGroup, Label, Input } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import GeneracionContactCenterTable from "./GeneracionContactCenter.table";
import { GeneracionContactCenterStore } from "../../../containers/comisionesContactCenter/generacion/GeneracionContactCenter.store";
import { GeneracionContactCenterDispatcher } from "../../../containers/comisionesContactCenter/generacion/GeneracionContactCenter.dispatcher";
import { ProcesoResultado } from "../../../../types/ContactCenterResumen";
import {
  errorNotification,
  successNotification
} from "../../../../utils/notifications";
import { Styled } from "../../../../toolkit/decorators/Artifact";

interface Props
  extends GeneracionContactCenterStore,
    GeneracionContactCenterDispatcher {}

interface State {
  selectedFile: File | null;
  selectedMes: string;
  selectedAnio: string;
  mostrarBotonConfirmar: boolean;
}

const MESES = [
  { value: "01", label: "Enero" },
  { value: "02", label: "Febrero" },
  { value: "03", label: "Marzo" },
  { value: "04", label: "Abril" },
  { value: "05", label: "Mayo" },
  { value: "06", label: "Junio" },
  { value: "07", label: "Julio" },
  { value: "08", label: "Agosto" },
  { value: "09", label: "Septiembre" },
  { value: "10", label: "Octubre" },
  { value: "11", label: "Noviembre" },
  { value: "12", label: "Diciembre" }
];

@Styled(s)
export default class GeneracionContactCenterComponent extends Component<
  Props,
  State
> {
  state = {
    selectedFile: null,
    selectedMes: "",
    selectedAnio: "",
    mostrarBotonConfirmar: false
  };

  componentDidMount() {
    const currentYear = new Date().getFullYear();
    this.setState({ selectedAnio: currentYear.toString() });
  }

  onFileChange = evt => {
    if (evt.target.files && evt.target.files.length > 0) {
      this.setState({
        selectedFile: evt.target.files[0],
        mostrarBotonConfirmar: false
      });
    }
  };

  onMesChange = evt => {
    this.setState({ selectedMes: evt.target.value });
  };

  onAnioChange = evt => {
    this.setState({ selectedAnio: evt.target.value });
  };

  getPeriodo = () => {
    const { selectedMes, selectedAnio } = this.state;
    if (!selectedMes || !selectedAnio) return "";
    return `${selectedAnio}-${selectedMes}-01`;
  };

  onCalcularComisiones = async () => {
    const { selectedFile } = this.state;

    if (!selectedFile) {
      errorNotification("Debe seleccionar un archivo");
      return;
    }

    const periodo = this.getPeriodo();
    if (!periodo) {
      errorNotification("Debe seleccionar mes y año");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    const preview = await this.props.postCalcularComisiones(
      formData,
      periodo,
      false
    );

    if (preview.fulfilled) {
      const resumen = preview.comisionContactCenterResumen;

      if (resumen && resumen.length > 0) {
        const hasErrors = resumen.some(
          r => r.resultado === ProcesoResultado.ERROR
        );

        if (!hasErrors) {
          successNotification(
            "Preview de comisiones generado. Revise los resultados y confirme."
          );
          this.setState({ mostrarBotonConfirmar: true });
        } else {
          errorNotification(
            "Algunos registros contienen errores. Revise la tabla."
          );
          this.setState({ mostrarBotonConfirmar: false });
        }
      } else {
        successNotification("Proceso completado");
        this.setState({ mostrarBotonConfirmar: false });
      }
    } else {
      errorNotification(
        preview.postingComisionContactCenterError ||
          "Error al calcular las comisiones"
      );
      this.setState({ mostrarBotonConfirmar: false });
    }
  };

  onConfirmarComisiones = async () => {
    const { selectedFile } = this.state;

    const periodo = this.getPeriodo();
    const formData = new FormData();
    formData.append("file", selectedFile);

    const preview = await this.props.postCalcularComisiones(
      formData,
      periodo,
      true
    );

    if (preview.fulfilled) {
      successNotification("Comisiones confirmadas y guardadas correctamente");
      this.setState({ mostrarBotonConfirmar: false, selectedFile: null });
    } else {
      errorNotification(
        preview.postingComisionContactCenterError ||
          "Error al confirmar las comisiones"
      );
    }
  };

  isWaiting = () => {
    return this.props.postingComisionContactCenter;
  };

  spinnerOnWait = (label: string) => {
    return this.isWaiting() ? (
      <FontAwesomeIcon icon={faSpinner} pulse />
    ) : (
      label
    );
  };

  render() {
    const { comisionContactCenterResumen: resumen } = this.props;
    const {
      selectedFile,
      selectedMes,
      selectedAnio,
      mostrarBotonConfirmar
    } = this.state;

    const anio = new Date().getFullYear();
    const anios = [anio, anio + 1];

    return (
      <>
        <div className="container">
          <div className="row mt-3">
            <div className="col-md-3">
              <FormGroup>
                <Label for="mes">Mes</Label>
                <Input
                  type="select"
                  name="mes"
                  id="mes"
                  value={selectedMes}
                  onChange={this.onMesChange}
                  disabled={this.isWaiting()}
                >
                  <option value="">Seleccione un mes</option>
                  {MESES.map(mes => (
                    <option key={mes.value} value={mes.value}>
                      {mes.label}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </div>

            <div className="col-md-3">
              <FormGroup>
                <Label for="anio">Año</Label>
                <Input
                  type="select"
                  name="anio"
                  id="anio"
                  value={selectedAnio}
                  onChange={this.onAnioChange}
                  disabled={this.isWaiting()}
                >
                  {anios.map(anio => (
                    <option key={anio} value={anio}>
                      {anio}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </div>
          </div>

          <div className="row mt-2">
            <div className="col-md-3">
              <Button
                type="button"
                className={`${s.primaryButton} ${s.fileButton}`}
                size="sm"
                block
                disabled={this.isWaiting()}
                onClick={e => {
                  if (this.isWaiting()) {
                    e.preventDefault();
                    e.stopPropagation();
                  }
                }}
              >
                {this.spinnerOnWait("Seleccionar archivo")}
                <input
                  className={s.inputFile}
                  type="file"
                  accept=".xlsx,.xls"
                  title=""
                  disabled={this.isWaiting()}
                  onChange={this.onFileChange}
                />
              </Button>
              {selectedFile && (
                <small className="text-muted d-block mt-1">
                  {selectedFile.name}
                </small>
              )}
            </div>

            <div className="col-md-3">
              <Button
                className={`${s.primaryButton}`}
                type="button"
                size="sm"
                block
                onClick={this.onCalcularComisiones}
                disabled={!selectedFile || this.isWaiting()}
              >
                {this.spinnerOnWait("Calcular comisiones")}
              </Button>
            </div>

            {mostrarBotonConfirmar && (
              <div className="col-md-3">
                <Button
                  color="success"
                  type="button"
                  size="sm"
                  block
                  onClick={this.onConfirmarComisiones}
                  disabled={this.isWaiting()}
                >
                  {this.spinnerOnWait("Confirmar comisiones")}
                </Button>
              </div>
            )}
          </div>

          {resumen && resumen.length > 0 && (
            <div className="mt-4">
              <GeneracionContactCenterTable resumen={resumen} />
            </div>
          )}
        </div>
      </>
    );
  }
}
